class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    
    // Only bind hover events on desktop
    if (window.innerWidth >= 990) {
      this.bindHoverEvents();
    }
    
    // Handle resize events
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 990) {
        this.bindHoverEvents();
      } else {
        this.unbindHoverEvents();
      }
    });
  }

  bindHoverEvents() {
    if (this.hoverBound) return;
    
    const megaMenus = document.querySelectorAll('.mega-menu');
    megaMenus.forEach(menu => {
      menu.addEventListener('mouseenter', () => {
        menu.setAttribute('open', '');
      });
      
      menu.addEventListener('mouseleave', () => {
        menu.removeAttribute('open');
      });
    });
    
    this.hoverBound = true;
  }

  unbindHoverEvents() {
    if (!this.hoverBound) return;
    
    const megaMenus = document.querySelectorAll('.mega-menu');
    megaMenus.forEach(menu => {
      menu.removeEventListener('mouseenter', () => {});
      menu.removeEventListener('mouseleave', () => {});
    });
    
    this.hoverBound = false;
  }
}

customElements.define('header-menu', HeaderMenu);
